import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { concatMap, map, tap } from 'rxjs/operators';
import { CookieManagementService } from 'src/app/account/services/cookie-management.service';
import { CreditCardPaymentReqParamsModel } from '../../models/credit-card-payment-models';
import { CreditCardPaymentInfo, TransactionRequestPayWCreditCardInputParamsModel } from '../../models/transaction-request-models';
import { TransactionResultReqParamsModel } from '../../models/transaction-result-models';
import { es3dgateService } from '../../services/3dsgate/3dsRequest.service';
import { TranscationRequestService } from '../../services/transaction-request/transcation-request.service';

@Component({
  selector: 'app-pay-with-credit-card',
  templateUrl: './pay-with-credit-card.component.html',
  styleUrls: ['./pay-with-credit-card.component.css']
})
export class PayWithCreditCardComponent implements OnInit {
  @Input() creditCardRequiredParams!: TransactionRequestPayWCreditCardInputParamsModel
  @Output() onError = new EventEmitter();

  private subscriptions = new Subscription();

  public bankPayWithCreditCardPage!:any;

  constructor(
    private transactionRequestService: TranscationRequestService,
    private cookieManagementService: CookieManagementService,
    private sanitizer: DomSanitizer,
    private es3dgateService: es3dgateService
  ) { }

  ngOnInit(): void {
    
    this.subscriptions.add(
      this.transactionRequestService.TransactionRequest<TransactionRequestPayWCreditCardInputParamsModel, CreditCardPaymentInfo>('pay-with-credit-card', this.creditCardRequiredParams)
      .pipe(
        tap(paymentInfo => {
          const amount = paymentInfo.posInfo.Amount;
          const transactionCompleteReqParams:TransactionResultReqParamsModel = {
            orderId: paymentInfo.orderId,
            refCode: paymentInfo.refCode
          };

          localStorage.setItem('tCompleteParams', JSON.stringify(transactionCompleteReqParams));
          localStorage.setItem('amount', JSON.stringify(amount));
          localStorage.setItem('payment-type', JSON.stringify('pay-with-credit-card'));
        }),
        map((transactionReqResponse:CreditCardPaymentInfo) =>{
          let payWithCreditCardParams:CreditCardPaymentReqParamsModel = {
            redirectURL: transactionReqResponse.redirectURL,
            clientid: transactionReqResponse.posInfo.ClientId,
            storetype: transactionReqResponse.posInfo.StoreType,
            hash: transactionReqResponse.posInfo.Hash,
            currency: transactionReqResponse.posInfo.Currency,
            okUrl: transactionReqResponse.posInfo.OkUrl,
            failUrl: transactionReqResponse.posInfo.FailUrl,
            rnd: transactionReqResponse.posInfo.Rnd,
            DESCRIPTION: transactionReqResponse.extraData,
            oid: transactionReqResponse.orderId,
            ref_code: transactionReqResponse.refCode,
            token: this.cookieManagementService.getAccessToken(),
            amount: transactionReqResponse.posInfo.Amount
          }

          return payWithCreditCardParams;
        }),
        concatMap(params => this.es3dgateService
          .service3dsRequest<CreditCardPaymentReqParamsModel>('pay-with-credit-card', params)!
        )
      )
      .subscribe(  
        resp => {
          this.bankPayWithCreditCardPage = this.sanitizer.bypassSecurityTrustHtml(resp);
        },
        err =>{
          this.onError.emit();
        }     
      )
    );

  }

}
